/**
 * Presentation helpers only.
 *
 * Everything that used to *compute* analytics here now comes from the server, which
 * is the only place that can be the single answer: iOS, this dashboard and any future
 * weekly email must not disagree about which children are struggling
 * (27-teacher-api-handoff.md §1).
 *
 * Deleted with that move: `atRiskReasons`, `isAtRisk`, `groupStats`, and the two
 * synthesised helpers `topicMasteryFor` / `scoreHistoryFor`, which generated
 * plausible-looking numbers from a seeded PRNG. Real topic mastery is far spikier
 * and real score histories have gaps — the screens now handle both.
 *
 * If the at-risk flag is ever too noisy for a school, that is one block of constants
 * in `school_analytics_service.py`, not a second threshold re-implemented here.
 */

/* Mastery genuinely is attainment, so this is the one place in the teacher
   tools that the marking pair belongs. Reads from tokens rather than hex so it
   follows the theme. */
export function masteryColor(value: number): string {
  if (value >= 75) return 'var(--awarded)'
  if (value >= 55) return 'var(--warn)'
  return 'var(--withheld)'
}

export function masteryTextClass(value: number): string {
  if (value >= 75) return 'text-awarded'
  if (value >= 55) return 'text-warn'
  return 'text-withheld'
}

export function average(nums: number[]): number {
  if (nums.length === 0) return 0
  return Math.round(nums.reduce((a, b) => a + b, 0) / nums.length)
}

export function formatMinutes(min: number): string {
  const h = Math.floor(min / 60)
  const m = min % 60
  if (h <= 0) return `${m}m`
  return `${h}h ${m}m`
}
